import { render, staticRenderFns } from "./InputTextareaButton.vue?vue&type=template&id=39993cd2"
import script from "./InputTextareaButton.vue?vue&type=script&lang=js"
export * from "./InputTextareaButton.vue?vue&type=script&lang=js"
import style0 from "./InputTextareaButton.vue?vue&type=style&index=0&id=39993cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports